export const tabs = [
  { id: "1", title: "Project Overview" },
  { id: "2", title: "Milestones" },
  { id: "3", title: "Budget" },
  { id: "4", title: "Payment Groups" },
  { id: "5", title: "Contract Details" },
  { id: "6", title: "Documents" },
];
export default tabs;

// export const statusStyleArray = [
//   {
//     status: "draft",
//     color: "#d46b08",
//     backgroundColor: "#fff7e6",
//   },
//   {
//     status: "draft-by-contractor",
//     color: "#d46b08",
//     backgroundColor: "#fff7e6",
//   },
//   {
//     status: "Requested",
//     backgroundColor: "#c41d7f",
//     color: "#fff0f6",
//   },
//   {
//     status: "awaiting-approval",
//     color: "#d4b106",
//     backgroundColor: "#feffe6",
//   },
//   {
//     status: "awaiting-contractor-confirmation",
//     color: "#c41d7f",
//     backgroundColor: "#fff0f6",
//   },
//   {
//     status: "approved-by-contractor",
//     backgroundColor: "#d46b08",
//     color: "#fff7e6",
//   },
//   {
//     status: "rejected-by-contractor",
//     color: "rgb(229, 71, 70)",
//     backgroundColor: "#fff0f6",
//   },
//   {
//     status: "proposed-to-client",
//     color: "#fff",
//     backgroundColor: "rgb(56, 158, 13)",
//   },
//   {
//     status: "completed",
//     color: "#f6ffed",
//     backgroundColor: "#2e6f40",
//   },
//   {
//     status: "in_warranty",
//     color: "#fff",
//     backgroundColor: "#c292fd",
//   },
//   {
//     status: "ongoing",
//     backgroundColor: "#096dd9",
//     color: "#e6f7ff",
//   },
//   {
//     status: "delivered",
//     color: "#389e0d",
//     backgroundColor: "#f6ffed",
//   },
// ];

export const statusStyleArray = [
  // {
  //   status: "draft",
  //   color: "#d46b08",
  //   backgroundColor: "#fff7e6",
  // },
  // {
  //   status: "draft-by-contractor",
  //   color: "#d46b08",
  //   backgroundColor: "#fff7e6",
  // },
  // {
  //   status: "Requested",
  //   backgroundColor: "#c41d7f",
  //   color: "#fff0f6",
  // },
  // {
  //   status: "awaiting-approval",
  //   color: "#d4b106",
  //   backgroundColor: "#feffe6",
  // },
  // {
  //   status: "awaiting-contractor-confirmation",
  //   color: "#c41d7f",
  //   backgroundColor: "#fff0f6",
  // },
  // {
  //   status: "approved-by-contractor",
  //   backgroundColor: "#d46b08",
  //   color: "#fff7e6",
  // },
  // {
  //   status: "rejected-by-contractor",
  //   color: "rgb(229, 71, 70)",
  //   backgroundColor: "#fff0f6",
  // },
  // {
  //   status: "proposed-to-client",
  //   color: "#fff",
  //   backgroundColor: "rgb(56, 158, 13)",
  // },
  // {
  //   status: "completed",
  //   color: "#f6ffed",
  //   backgroundColor: "#2e6f40",
  // },
  // {
  //   status: "in_warranty",
  //   color: "#fff",
  //   backgroundColor: "#c292fd",
  // },
  // {
  //   status: "ongoing",
  //   color: "#096dd9",
  //   backgroundColor: "#e6f7ff",
  // },
  // {
  //   status: "delivered",
  //   color: "#389e0d",
  //   backgroundColor: "#f6ffed",
  // },
  {
    status: "draft",
    backgroundColor: "#d46b08",
  },
  {
    status: "draft-by-contractor",
    backgroundColor: "#d46b08",
  },
  {
    status: "Requested",
    backgroundColor: "#c41d7f",
  },
  {
    status: "awaiting-approval",
    backgroundColor: "#d4b106",
  },
  {
    status: "awaiting-contractor-confirmation",
    backgroundColor: "#c41d7f",
  },
  {
    status: "approved-by-contractor",
    backgroundColor: "#d46b08",
  },
  {
    status: "rejected-by-contractor",
    backgroundColor: "rgb(229, 71, 70)",
  },
  {
    status: "proposed-to-client",
    backgroundColor: "rgb(56, 158, 13)",
  },
  {
    status: "completed",
    color: "#f6ffed",
    backgroundColor: "#2e6f40",
  },
  {
    status: "in_warranty",
    backgroundColor: "#c292fd",
  },
  {
    status: "ongoing",
    backgroundColor: "#096dd9",
  },
  {
    status: "delivered",
    color: "#389e0d",
    backgroundColor: "#f6ffed",
  },
];

export const milestoneStatusStyleArray = [
  {
    status: "ongoing",
    color: "#096dd9",
    backgroundColor: "#e6f7ff",
  },
  {
    status: "Not Started",
    color: "#c41d7f",
    backgroundColor: "#fff0f6",
  },
  {
    status: "delivered",
    backgroundColor: "#389e0d",
    color: "#fff",
  },
  {
    status: "pending",
    color: "#d46b08",
    backgroundColor: "#fff7e6",
  },
  {
    status: "completed",
    backgroundColor: "rgb(56, 158, 13)",
    color: "#fff",
  },
  {
    status: "change_request",
    color: "#c41d7f",
    backgroundColor: "#fff0f6",
  },
  { status: "due", backgroundColor: "#d46b08", color: "#fff7e6" },
  { status: "closed", color: "rgb(229, 71, 70)", backgroundColor: "#fff0f6" },
];

export const paymentStatusStyleArray = [
  { status: "due", backgroundColor: "#d46b08", color: "#fff7e6" },
  {
    status: "ongoing",
    color: "#096dd9",
    backgroundColor: "#e6f7ff",
  },
  {
    status: "Created",
    color: "#d46b08",
    backgroundColor: "#fff7e6",
  },
  {
    status: "CREATED",
    color: "#d46b08",
    backgroundColor: "#fff7e6",
  },
  {
    status: "INITIATED",
    backgroundColor: "#096dd9",
    color: "#e6f7ff",
  },
  {
    status: "completed",
    backgroundColor: "rgb(56, 158, 13)",
    color: "#fff",
  },
  {
    status: "Not Started",
    color: "#c41d7f",
    backgroundColor: "#fff0f6",
  },
  {
    status: "PAID",
    backgroundColor: "rgb(56, 158, 13)",
    color: "#fff",
  },
  {
    status: "delivered",
    backgroundColor: "#389e0d",
    color: "#fff",
  },
];
